import React from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";

interface CustomInputProps {
  label: string;
  name: string;
  type?: "text" | "date" | "file";
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  isVersioned?: boolean;
  versionedValue?: string;
  readOnly?: boolean;
}

const CustomInput: React.FC<CustomInputProps> = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  error,
  required = false,
  placeholder = "",
  disabled = false,
  isVersioned = false,
  readOnly = false,
  versionedValue = "",
}) => {
  return (
    <div className="w-full">
      <label className="block font-medium mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      {isVersioned ?
        <input
          type={type}
          name={name}
          value={versionedValue}
          onChange={onChange}
          className={`form-input w-full mb-2 ${error ? "border-red-500" : "border-gray-300"
            } ${disabled ? "cursor-not-allowed opacity-80" : ""}`}
          placeholder={placeholder}
          disabled={true}
          readOnly={readOnly}
        />
        :
        null
      }
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        className={`form-input w-full ${error ? "border-red-500" : "border-gray-300"
          } ${disabled ? "cursor-not-allowed opacity-80" : ""}`}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default CustomInput;
